import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inscription-info-page',
  templateUrl: './inscription-info-page.component.html',
  styleUrls: ['./inscription-info-page.component.scss']
})
export class InscriptionInfoPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
